import { render, staticRenderFns } from "./VsmGroupMessageLinkButton.vue?vue&type=template&id=bfd64d2e&"
import script from "./VsmGroupMessageLinkButton.vue?vue&type=script&lang=js&"
export * from "./VsmGroupMessageLinkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports